import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { DEFAULT_LANGUAGE } from "../utils/global_const";
import Header from "../layouts/header/Header";
import Footer from "../layouts/footer/Footer";
import BrandsMain from "../layouts/main/BrandsMain";

const Container = styled.div`
  background-color: var(--background-color);
  color: var(--text-color);
`;

const SEOConfig = {
  en: {
    lang: "en",
    title: "All Brands | SnusCo",
    description:
      "Browse every nicotine pouch brand available at SnusCo, from best sellers to new arrivals.",
    og: {
      title: "All Brands | SnusCo",
      description:
        "Browse every nicotine pouch brand available at SnusCo, from best sellers to new arrivals.",
    },
  },
  de: {
    lang: "de",
    title: "Alle Marken | SnusCo",
    description:
      "Entdecken Sie alle Nikotinbeutel-Marken bei SnusCo, von Bestsellern bis zu Neuheiten.",
    og: {
      title: "Alle Marken | SnusCo",
      description:
        "Entdecken Sie alle Nikotinbeutel-Marken bei SnusCo, von Bestsellern bis zu Neuheiten.",
    },
  },
};

const Brands = () => {
  const { i18n } = useTranslation();
  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <Container>
      <Helmet>
        <html lang={seo.lang} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.og.title} />
        <meta property="og:description" content={seo.og.description} />
        <meta property="og:type" content="website" />
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Header />
      <BrandsMain />
      <Footer />
    </Container>
  );
};

export default Brands;
